/*** IMPORTS FROM imports-loader ***/
(function() {

define([
        'pip-events',
        'window'
    ],
    function(
        pipEvents,
        window
    ){

        function initEventListeners(){

            pipEvents.cart.multiItemAddToCart.on(function(evtType, data) {

                if(window.digitalData && window.digitalData.event) {
                    window.digitalData.event.push({
                        eventInfo: {
                            eventName: 'recommendation cart addition'
                        },
                        eventMode: 'stash',
                        category: {
                            primaryCategory: 'stash'
                        },
                        isReport: true,
                        stash: {
                            component: data.component,
                            pageType: data.pageType,
                            section: data.section,
                            target: data.target,
                            sharedSection: data.sharedSection,
                            item: data.item
                        }
                    });
                }
            });

            pipEvents.cart.addtoCartOverlay.on(function(evtType, data) {
                if(window.digitalData && window.digitalData.event) {
                    window.digitalData.event.push({
                        eventInfo: {
                            eventName: 'cart add'
                        },
                        category: {
                            primaryCategory: 'overlay'
                        },
                        item: data.itemsModel
                    });
                }
            });

        }

        return {
            init: function(){
                initEventListeners();
            }
        }

    });

}.call(window));